import React from 'react'

import PriceDetails, {
  buildDaysPriceLabel,
} from 'tripPlanner/components/ItemOfferPrice/PriceDetails'

import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

interface Props {
  purchasableOption: App.Tours.TourV2OfferPurchasableOption
  duration: number | null
  depositComponent: React.ReactNode
  currencyCode: string
  discountDisplayType?: React.ComponentProps<
    typeof PriceDetails
  >['discountDisplayType']
}

function TourV2OfferCardPriceDetails({
  purchasableOption,
  duration,
  depositComponent,
  currencyCode,
  discountDisplayType = 'badge',
}: Props) {
  const isLuxPlusMember = useAppSelector(getCanViewLuxPlusBenefits)
  const purchasableOptionDetails =
    useTourV2PurchasableOptionDetails(purchasableOption)
  if (!duration || !purchasableOptionDetails) return null
  return (
    <PriceDetails
      price={purchasableOptionDetails.pricePerPerson}
      luxPlusPrice={purchasableOptionDetails.memberPricePerPerson}
      discount={isLuxPlusMember ? purchasableOptionDetails.valuedAt?.memberSavingsPercentage : purchasableOptionDetails.valuedAt?.savingPercentage}
      currencyCode={currencyCode}
      priceLabel={buildDaysPriceLabel(duration, duration)}
      totalLabel="/person"
      discountDisplayType={
        purchasableOptionDetails.hasDiscount ? discountDisplayType : 'none'
      }
      roomOccupancy={purchasableOptionDetails.roomTypeName ?? undefined}
      depositComponent={depositComponent}
    />
  )
}

export default TourV2OfferCardPriceDetails
